import styled from 'styled-components';

export const GroupingContainer = styled.div`
  padding: ${({ theme }) => `0 0 ${theme.spacing(6)} 0`};
`;
